// https://codepen.io/tashfene/pen/raEqrJ
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { DetermineLogo } from '../../../themes/logoFunctions'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

export function GlobalLoader (): ReactElement {
  const { siteTheme: { globalLoaderColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <>
      <div className="fixed z-30 block top-0 left-0 w-full h-full bg-gray-700 opacity-60" />
      <div className="w-full h-screen flex justify-center items-center fixed inset-0 z-40">
        <div className="absolute w-32 z-50">
          <DetermineLogo />
        </div>
        <div className={cn(globalLoaderColors.borderClasses, 'rounded-lg relative z-40 animate-loader w-48 h-48 border-4 ')}>
          <div className={cn(globalLoaderColors.backgroundClasses, 'animate-loader-inner w-full align-top absolute')} />
        </div>
      </div>
    </>
  )
}
